itsoftApp.createModule("CustomToggleChoose", function () {
    var module = this;

    var initCustomToggleChoose = function () {
        var activeClass = '_active';
        var toggleClass = '_toggled';
        var triggers = document.querySelectorAll('.js-choose-trigger');
        var links = document.querySelectorAll('a.choose-instruction__link');
        var isCurOpen;
        var curTarget;
        var target;

        if (triggers) {
            triggers.forEach((el) => {
                el.addEventListener('click', (e) => {
                    e.preventDefault();
                    target = e.target;
                    target.closest('.js-choose-trigger-wrapper').classList.toggle(toggleClass);
                });
            });
        };

        if (links) {
            links.forEach((el) => {
                el.addEventListener('click', (e) => {
                    isCurOpen = e.currentTarget.classList.contains(activeClass);
                    curTarget = e.currentTarget;
                    if (isCurOpen) {
                        curTarget.classList.remove(activeClass);
                    } else {
                        links.forEach((el) => {
                            el.classList.remove(activeClass);
                        });
                        curTarget.classList.add(activeClass);
                    };
                });
            });
        };
    };

    initCustomToggleChoose();

    module.callback = initCustomToggleChoose;
});
